module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow1-429957449e231c760d9a0a214c6ff122.svg";